import React from 'react';
import loadable from '@loadable/component';
import { BrowserRouter as BaseRouter, Switch, Route } from 'react-router-dom';
import _ from 'lodash';
import { routes } from '../../routes';
import ScrollToTop from './ScrollToTop';

const loadableFor = (key, name) => ({
  [key]: loadable(() => import(`../../containers/${name}/${name}.jsx`)),
});

const loadablesOf = (routes, custom) => {
  let loadables = {};

  _.forEach(routes, (value, key) => {
    loadables = {
      ...loadables,
      ...loadableFor(key, value.container || value.name),
    };
  });

  return {
    ...loadables,
    ...custom,
  };
};

const loadables = loadablesOf(routes, {
  ...loadableFor('notFound', 'NotFound'),
});

const MainRouter = ({ history }) => (
  <BaseRouter history={history}>
    <ScrollToTop />
    <Switch>
      <Route
        exact
        key={routes.root.path}
        path={routes.root.path}
        component={loadables.root}
      />
      <Route
        exact
        key={routes.home.path}
        path={routes.home.path}
        component={loadables.home}
      />
      <Route
        exact
        key={routes.termsAndConditions.path}
        path={routes.termsAndConditions.path}
        component={loadables.termsAndConditions}
      />
      <Route
        exact
        key={routes.privacyPolicy.path}
        path={routes.privacyPolicy.path}
        component={loadables.privacyPolicy}
      />
      <Route path="*" component={loadables.notFound} />
    </Switch>
  </BaseRouter>
);

export { routes, loadables, MainRouter };
